<template>
  <b-container>

    <b-row class="d-flex flex-row justify-content-center w-100">
      <h3>اضافه کردن کاربر به محصول</h3>
    </b-row>

    <b-row class="d-flex flex-row justify-content-center w-100">
      <p>ابتدا محصول مورد نظر را انتخاب کنید و سپس کاربران مورد نظر خود را اضافه نمایید</p>
    </b-row>

    <b-row class="border rounded set-height text-center p-1">
      <b-col lg="6" class="mt-3 ml-auto mr-auto">
        <b-form-input placeholder="جست و جو در محصولات" v-model="searchOnProduct" @keyup.enter="searchProducts"/>
      </b-col>

      <b-col cols="12" class="d-flex flex-column align-items-center w-100 px-2 py-3 product-col rounded">
        <div v-for="(product,index) in products" :key="index">
          <div v-for="(sub_product,index) in subProducts(product)" :key="index*2">


            <span class="selected_item cursor_pointer p-2 ml-2 rounded" v-if="activeProduct(sub_product)">
            {{ sub_product.name }} {{ productType(product) }}
          </span>
            <span class="ml-2 cursor_pointer" @click="loadUsers(sub_product)" v-else>
              {{ sub_product.name }} {{ productType(product) }}
            </span>
            <hr class="text-secondary w-100">
          </div>

        </div>
        <p v-if="products.length==0" class="text-center">هیچ محصولی یافت نشد!</p>
      </b-col>

    </b-row>

    <b-row class="">
      <b-form class="w-100" @submit.prevent>

        <b-row class=" my-2 p-2">

          <b-col lg="6" md="5" sm="12" class="mt-2 ml-atuo mr-auto rounded border shadow ">

            <p class="text-muted text-center mt-2 font-weight-bold">کاربران محصول</p>
            <div class="items mt-3">
                <span class="d-block cursor_pointer" v-for="(user,index) in productUsers" :key="index">
                     <b-icon class="bg-danger rounded-pill text-white" @click="removeUser(user)" icon="x"></b-icon>
                  {{ user.name + ' ' + user.last_name }}
                  <hr class="text-secondary w-100">

                </span>
              <p v-if="productUsers.length==0" class="text-center">هیچ کاربری یافت نشد!</p>
            </div>

          </b-col>

          <b-col lg="6" md="5" sm="12" class="mt-2 ml-atuo mr-auto rounded border shadow ">
            <p class="text-muted text-center mt-2 font-weight-bold">کاربران</p>

            <form @submit.prevent="" class="col-lg-12 my-3">
              <b-form-input class="col-lg-12" v-model="searchOnUsers"
                            placeholder="نام، نام خانوادگی یا شماره تلفن کاربر"
                            @keyup.enter="searchUsers"/>
            </form>

            <div class="items">
                <span class="d-block cursor_pointer" @click="addUserToProduct(user)"
                      v-for="user in users" :key="user.id" v-if="isInProductUsers(user.id) === false">
                  {{ user.name + ' ' + user.last_name }}
                  <hr class="text-secondary w-100">
                </span>
              <p v-if="users.length==0" class="text-center">هیچ کاربری یافت نشد!</p>
            </div>
          </b-col>

        </b-row>

      </b-form>
    </b-row>
  </b-container>
</template>

<script>
import FormGroup from "../../components/validator/FormGroup"
import FormErrorsManager from '../../components/validator/FormErrorsManager.vue'
import {mapGetters} from "vuex";
import {subProducts} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";

export default {
  name: "AddUserToProduct",
  components: {FormGroup, FormErrorsManager},
  data() {
    return {
      selectedProduct: {product_id: '', sub_product_id: ''},
      searchOnUsers: '',
      filteredUser: [],
      searchOnProduct: '',
    }
  },
  computed: {
    ...mapGetters({
      products: "Product/getProducts",
      users: "User/getPersons",
      productUsers: "Product/getProductUsers"
    })
  },
  methods: {
    async loadUsers(product) {

      if (product.variation == 0) {
        this.selectedProduct.product_id = product.id
        this.selectedProduct.sub_product_id = ""
      }

      if (product.variation == 1) {
        this.selectedProduct.product_id = product.id
        this.selectedProduct.sub_product_id = product.sub_product_id

      }
      await this.$store.dispatch("Product/getProductUsers", this.selectedProduct)
    },
    searchProducts() {
      if (this.searchOnProduct.trim() !== '') {
        this.$store.commit('Product/setFilters', {key: 'search', value: this.searchOnProduct})
        this.$store.commit('Product/setFilters', {key: 'is_digital', value: ''})
        this.$store.dispatch('Product/filteredProducts');
      }

    },
    isInProductUsers(userId) {
      let response = false
      this.productUsers.forEach(user => {
        if (userId === user.id) {
          response = true
        }
      })
      return response
    },
    async addUserToProduct(user) {

      if (this.selectedProduct.product_id !== '' || this.selectedProduct.sub_product_id !== '') {


        let form = {...this.selectedProduct, user_id: user.id}

        this.$store.dispatch("Product/addUserToProduct", form).then(res => {
          this.$store.dispatch("Product/getProductUsers", this.selectedProduct)
        })

      }
    },
    searchUsers() {
      if (this.searchOnUsers.trim() !== '') {
        const form = {
          words: this.searchOnUsers,
        }
        this.$store.dispatch('User/searchUsers', {form});
      }
    },
    async removeUser(user) {
      if (confirm('آیا از حذف این کاربر اطمینان دارید؟')) {

        const form = {...this.selectedProduct, user_id: user.id, order_id: user.order_id}
        await this.$store.dispatch("Product/removeUserProduct", form).then(res => {
          this.$store.dispatch("Product/getProductUsers", this.selectedProduct)
        })

      }
    },
    productType(product) {
      return product.is_digital == 0 ? '(فیزیکی)' : '(دیجیتال)'
    },
    subProducts,
    activeProduct(product) {
      if (product.variation == 0) {
        return product.id == this.selectedProduct.product_id
      }

      return product.sub_product_id == this.selectedProduct.sub_product_id

    }
  },
  async mounted() {
    this.$store.commit('Product/setFilters', {key: 'is_digital', value: ''})
    await this.$store.dispatch("Course/getProducts");
    await this.$store.dispatch("User/getPersons")
  }
}
</script>

<style scoped>

.set-height {
  height: 350px !important;
}

.product-col {
  overflow-y: scroll;
  height: 180px !important;
}

.cursor_pointer {
  cursor: pointer;
}

.items {
  height: 400px !important;
  overflow-y: scroll;
}


.selected_item {
  background-color: var(--secondary);
  color: white;
}
</style>